import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-832aef33-dcbd-452a-861c-6bd865dc963a-__Layer_1",
  "enable-background": "new 0 0 64 64",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 1010.138 711.73 C 873.956 575.549 737.775 439.367 601.593 303.186 C 582.48 284.072 563.367 264.959 544.253 245.846 C 525.14 226.733 494.081 226.733 477.357 245.846 C 341.175 382.028 207.383 515.82 71.201 652.002 C 52.088 671.115 32.975 690.228 13.862 709.341 C -29.143 752.346 37.753 821.631 80.758 776.237 C 216.94 640.056 350.732 506.263 486.914 370.082 C 494.081 362.914 503.638 353.358 510.805 346.19 C 635.041 470.426 759.277 594.662 885.902 721.287 L 943.242 778.627 C 986.246 821.631 1053.142 754.735 1010.138 711.73 Z",
      style: {"transform-box":"fill-box","transform-origin":"50% 50%"},
      transform: "matrix(0, 1, -1, 0, 0.000015, -0.000035)"
    }, null, -1)
  ]))]))
}
export default { render: render }